import React, { Component } from "react";
import classnames from "classnames";

import * as styles from "./TabButtonGroup.scss";

export interface ITabButtonGroupProps {
    mode: "top" | "side";
    className?: string;
    children?: React.ReactNode;
}

export class TabButtonGroup extends Component<ITabButtonGroupProps> {
    public render() {
        const { children, className, mode } = this.props;
        return (
            <div
                className={classnames(
                    styles["tab-button-group"],
                    styles[mode],
                    className,
                )}
            >
                {children}
            </div>
        );
    }
}
